import { ClubEmptyState } from "@/features/MyClub/EmptyClub/ClubEmptyState";
import { clubStatsSelector, myClubSelector } from "@repo/shared/redux";
import { useClubImportFeature } from "@repo/shared/redux";
import { useSelector } from "react-redux";

import { SbcFodderBreakdownTable } from "./components/SbcFodderBreakdownTable";

export const MyClubSbcFodderBreakdown = () => {
  const clubStats = useSelector(clubStatsSelector);
  const { fetchClubStatsStatus } = useSelector(myClubSelector);
  /*
    Club stats are only fetched for a club that exists, so without one the
    status never leaves idle and the table would sit on "Loading..." forever.
  */
  const clubAccess = useClubImportFeature("see-own-players");
  const clubMissing = !clubAccess.allowed && clubAccess.reason !== "loading";

  // The title lives in the My Club header; the table fills the page.
  return clubMissing ? (
    <div className="px-4 py-6 mobile:px-6">
      <ClubEmptyState context="sbc-fodder" section="My Club" />
    </div>
  ) : (
    <SbcFodderBreakdownTable
      calculation={clubStats.sbcFodderCalculation}
      fetchClubStatsStatus={fetchClubStatsStatus}
    />
  );
};
